import { Component, inject } from '@angular/core';
import { ConsumableService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ConsumableCreateDto,
  ConsumableDto,
  ConsumableExcelDownloadDto,
  ConsumableUpdateDto,
} from 'orchestrator';
import { CONSUMABLE_CONFIG, CONSUMABLE_FIELDS } from './consumable.config';
import { BaseHierarchicalCrudComponent, GenericForm, ZnHierarchicalViewComponent } from '@zendra/shared';
import { CommonModule } from '@angular/common';
import { FieldMapperHelper } from '@zendra/shared';

@Component({
  selector: 'app-consumable',
  imports: [
    CommonModule,
    GenericForm,
    ZnHierarchicalViewComponent,
  ],
  providers: [ListService, ConsumableService, ConfirmationService],
  templateUrl: './consumable.html',
  styleUrl: './consumable.scss',
})
export class Consumable extends BaseHierarchicalCrudComponent<
  ConsumableDto,
  ConsumableCreateDto,
  ConsumableUpdateDto,
  ConsumableExcelDownloadDto
> {
  service = inject(ConsumableService);
  config = CONSUMABLE_CONFIG;
  fields = CONSUMABLE_FIELDS;

  private gridHookIntervalId: any;
  private gridHooked = false;

  constructor() {
    super();

    const fkDef = this.fields.find(f => f.key === 'consumableTypeId') as any;
    if (fkDef?.column) {
      fkDef.column = {
        ...fkDef.column,
        editable: false,
        editor: undefined,
        cssClass: ((fkDef.column.cssClass ? fkDef.column.cssClass + ' ' : '') + 'read-only'),
      };

      fkDef.column.cssClass = (fkDef.column.cssClass ? fkDef.column.cssClass + ' ' : '') + 'read-only';
    }
  }

  override ngAfterViewInit(): void {
    super.ngAfterViewInit();

    this.gridHookIntervalId = setInterval(() => {
      if (this.gridHooked) {
        clearInterval(this.gridHookIntervalId);
        return;
      }

      const grid = (this as any).crudPage?.gridTable?.grid;
      if (!grid) {
        return;
      }

      const slick = grid.slickGrid;
      if (!slick?.onBeforeEditCell) {
        clearInterval(this.gridHookIntervalId);
        return;
      }

      slick.onBeforeEditCell.subscribe((_e: any, args: any) => {
        const field = args?.column?.field ?? args?.column?.id;

        if (field === 'consumableTypeId') {
          return false;
        }
        return true;
      });

      this.gridHooked = true;
      clearInterval(this.gridHookIntervalId);
    }, 250);
  }

  override ngOnDestroy(): void {
    if (this.gridHookIntervalId) {
      clearInterval(this.gridHookIntervalId);
    }
    super.ngOnDestroy();
  }

  override edit(row: ConsumableDto): void {
    this.selectedEntity = { ...row };

    const fields = FieldMapperHelper.mapFieldsForForm(this.fields, row, this.injector).map(f => ({
      ...f,
      required: f.required,
      validators: f.validators
    }));

    const consumableTypeField = fields.find(f => (f as any).key === 'consumableTypeId') as any;
    if (consumableTypeField) {
      consumableTypeField['disabled'] = true;
      consumableTypeField['readOnly'] = true;

      if (consumableTypeField['fieldOptions']) {
        consumableTypeField['fieldOptions'] = {
          ...consumableTypeField['fieldOptions'],
          disabled: true,
          readOnly: true,
        };
      }

      if (consumableTypeField['templateOptions']) {
        consumableTypeField['templateOptions'] = {
          ...consumableTypeField['templateOptions'],
          disabled: true,
          readonly: true,
        };
      }

      if (consumableTypeField['formControl']?.disable) {
        consumableTypeField['formControl'].disable({ emitEvent: false });
      }
    }

    this.genericForm.open({
      title: `${this.localizationResource.LanguageService}::EditRecord`,
      fields,
      entityLocaleKey: this.config.localizationKey
    });
  }

  protected prepareUpdateDto(data: any, selected: ConsumableDto): ConsumableUpdateDto {
    return {
      code: data.code,
      name: data.name,
      isActive: data.isActive,
      deactivationReasonId: data.deactivationReasonId,
      deactivationDate: data.deactivationDate,
      sapCode: data.sapCode,
      vendorId: data.vendorId,
      internalOrderId: data.internalOrderId,
      notes: data.notes,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Consumable';
  }
}
